<bp-lottie-player animationName="spinning-logo" looped eager></bp-lottie-player>
